import React from 'react';

import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarVat,
  setPage,
} from '@/store/reducers/cars-stock';
import StockFilterSelect from '@/components/StockFilterSelect';
import { convertFilterParamsToOptionsByKey } from '@/modules/CarsStock/components/common.helpers';

function VatFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedVat =
    useTypedSelector(getSelectedFilters).selectedParams.selectedVat;

  const vatOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'vats'
  );

  const handleChangeVats = (vat: OptionType) => {
    dispatch(setCarVat(vat));
    dispatch(setPage(1));
  };

  const handleClearVats = () => {
    dispatch(setCarVat({ label: '', value: '' }));
    dispatch(setPage(1));
  };

  return (
    <StockFilterSelect
      label="НДС"
      value={selectedVat}
      options={vatOptions}
      onChange={handleChangeVats}
      onClear={handleClearVats}
    />
  );
}

export default VatFilter;
